<template>
    <div class="page-user-edit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">同城配送</div>
            <div class="breadcrumb-item">同城用戶列表(子號) 增加</div>
        </div>

        <div class="pg-block">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-form-wrap">
                <Row>
                    <Col span="18" push="5">
                        <Form :label-width="150">
                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>子帳號</span>
                                        </div>
                                        <Input v-model="form.username" clearable/>
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>子帳號用戶名稱</span>
                                        </div>
                                        <Input v-model="form.realname" clearable/>
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>密碼</span>
                                        </div>
                                        <Input v-model="form.password" type="password" clearable/>
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>主號ID</span>
                                        </div>

                                        <Select size="small" style="width: 120px;" placeholder="選擇主號ID" v-model="form.parent_id">
                                            <Option :value="item.id" v-for="(item, index) in samecityList"
                                                    :key="item.id">{{item.name}}
                                            </Option>
                                        </Select>

                                    </FormItem>
                                </Col>
                            </Row>


                            <FormItem>
                                <div class="pg-btn-wrap">
                                    <div class="pg-btn style1" @click="handleCheckForm">增加</div>
                                    <div class="pg-btn" @click="handleBack">返回</div>
                                    <!-- <Button type="error" :loading="true" class="loading-btn">
                                         <span>Loading...</span>
                                     </Button>-->
                                </div>
                            </FormItem>
                        </Form>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data()
        {
            return {
                isSubmiting: false,
                samecityList: [],
                form: {
                    username: '',
                    realname: '',
                    password: '',
                    parent_id: '',
                }
            };
        },
        mounted() {
            this.getSamcityList();
        },
        methods: {
            handleBack()
            {
                this.$router.go(-1);
            },
            handleCheckForm()
            {
                let form = this.form;

                if (form.username === '')
                {
                    this.$Utils.showTipInfo('請輸入子帳號');
                    return;
                } else if (form.realname === '')
                {
                    this.$Utils.showTipInfo('請輸入子帳號用戶名稱');
                    return;
                } else if (form.password === '')
                {
                    this.$Utils.showTipInfo('請輸入密碼');
                    return;
                } else if (form.parent_id === '')
                {
                    this.$Utils.showTipInfo('請選擇主號ID');
                    return;
                } 

                this.handleSubmit();

            },
            getSamcityList()
            {
                this.$Rq.requestAuth({
                    url: this.$Api.samecityUserList,
                    method: 'get',
                }).then((res) =>
                {
                    if (res.code == 0)
                    {
                        this.samecityList = res.data.data;
                    }
                });
            },
            handleSubmit()
            {
                let form = this.form;
                this.isSubmiting = true;

                this.$Rq.requestAuth({
                    url: this.$Api.samecityChildAdd,
                    method: 'post',
                    data: {
                        username: form.username,
                        realname: form.realname,
                        password: form.password,
                        parent_id: Number(form.parent_id),
                    }
                }).then((res) =>
                {
                    this.isSubmiting = false;

                    if (res.code == 0)
                    {
                        this.$Utils.showSuccess(res.msg);
                        this.form = {
                            username: '',
                            realname: '',
                            password: '',
                            parent_id: '',
                        };
                    } else
                    {
                        this.$Utils.showTipInfo(res.msg);
                    }
                }).catch((err) =>
                {
                    this.isSubmiting = false;
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "samecityChildlistAdd.scss";
</style>